
import { bindCode, resetGoogleCode } from '@/api/admin'
import { Form as ElForm } from 'element-ui'
import { secretRules } from '@/utils/rules'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { operationMessage } from '@/utils/message'
@Component({
  name: 'secret',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) id!: number
  @Prop({ default: true }) isReset!: boolean

  private infoForm: any = {
    google_code: '',
    description: ''
  }
  private rules = secretRules
  private loading: boolean = false

  private async save () {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        try {
          const data: any = {
            id: this.id,
            ...this.infoForm
          }
          if (this.isReset) {
            await resetGoogleCode(data).then((res: any) => {
              operationMessage(true)
              this.back()
              this.loading = false
            })
          } else {
            await bindCode(data).then((res: any) => {
              operationMessage(true)
              this.back()
              this.loading = false
            })
          }
        } catch (e) {
          this.loading = false
        }
      } else {
        return false
      }
    })
  }

  private back () {
    this.$emit('close')
  }

  created () {}
}
